export const blobFromUrl = async (url: string) => {
    return await(await fetch(url)).blob();
};